export type IValueGetter<T> = () => T;

export class ValueProvider<T> {
    getValue: IValueGetter<T>;

    constructor(getValue: IValueGetter<T>) {
        this.getValue = getValue;
    }

    static create<V>(value: V): ValueProvider<V> {
        return new ValueProvider<V>(() => value);
    }
}
